/**
 * Funzioni API per la Dashboard KEV.
 *
 * - `fetchKevCatalog`  → aggregation-service GET /kev/catalog (intero catalogo CISA KEV).
 * - `fetchKevLastSync` → monitoring-service GET /status/banner, estrae lastSyncAt della sorgente 'kev'
 *   (istante dell'ultima sincronizzazione KEV riuscita). Null se mai sincronizzato o sorgente assente.
 */

import { createServiceClient } from '../../api/client.js';
import type { KevCatalogEntry } from './types.js';

const aggregationApi = createServiceClient('aggregation');
const monitoringApi = createServiceClient('monitoring');

/** Shape parziale di GET /status/banner del monitoring-service (solo ciò che serve qui). */
interface StatusBannerResponse {
  sources: Array<{ name: string; lastSyncAt: string | null; ageHours: number | null }>;
}

/**
 * Recupera l'intero catalogo CISA KEV.
 * GET /kev/catalog → array di voci (knownExploited sempre true).
 */
export function fetchKevCatalog(): Promise<KevCatalogEntry[]> {
  return aggregationApi<KevCatalogEntry[]>('/kev/catalog');
}

/**
 * Recupera l'istante ISO dell'ultima sincronizzazione KEV riuscita.
 * GET /status/banner (monitoring-service) → sources[name='kev'].lastSyncAt.
 * Ritorna null se la sorgente 'kev' non è presente o non è mai stata sincronizzata.
 */
export async function fetchKevLastSync(): Promise<string | null> {
  const banner = await monitoringApi<StatusBannerResponse>('/status/banner');
  const kev = banner.sources?.find((s) => s.name === 'kev');
  return kev?.lastSyncAt ?? null;
}
